import '../../App.css'
import { useEffect, useState } from 'react'
import axios from 'axios'
import Aside from '../../component/aside'
import { useNavigate } from 'react-router-dom'
import Navbar from '../../component/navbar'
import Loading from '../../component/loading'

function Sections() {
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        if (!JSON.parse(localStorage.getItem('authResult'))) {
            navigate('/login')
        }
    }, [])
    const [dataGet, setDataGet] = useState([])
    let navigate = useNavigate()

    useEffect(() => {
        setLoading(true)
        axios
            .get('http://188.121.105.111:3000/sections')
            .then((res) => {
                setDataGet(res.data)
                setLoading(false)
            })
            .catch((error) => {
                setLoading(false)
            })
    }, [])

    return (
        <>
            {loading ? <Loading /> : null}
            <div className="container">
                <Aside />
                <main className="main-content">
                    <Navbar />
                    <div className="box transaction-box">
                        <div className="header-container">
                            <h3 className="section-header">لیست بخش ها</h3>
                            <button
                                className="btn main-clr-bg white-clr"
                                onClick={() => {
                                    navigate('/sectionAdd')
                                }}
                            >
                                افزودن
                            </button>
                        </div>
                        <table className="transaction-history">
                            <tr>
                                <th>نام</th>
                                <th>
                                    {' '}
                                    سرپرست
                                    <svg
                                        width={12}
                                        height={12}
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M9.96004 4.47498L6.70004 7.73498C6.31504 8.11998 5.68504 8.11998 5.30004 7.73498L2.04004 4.47498"
                                            stroke="#90A3BF"
                                            strokeWidth="1.5"
                                            strokeMiterlimit={10}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </th>
                                <th>
                                    {' '}
                                    ویرایش
                                    <svg
                                        width={12}
                                        height={12}
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M9.96004 4.47498L6.70004 7.73498C6.31504 8.11998 5.68504 8.11998 5.30004 7.73498L2.04004 4.47498"
                                            stroke="#90A3BF"
                                            strokeWidth="1.5"
                                            strokeMiterlimit={10}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </th>
                            </tr>
                            {dataGet.map((d) => {
                                return (
                                    <tr>
                                        <td>{d.name}</td>
                                        <td>{d.userId.fullName}</td>
                                        <td className="input-td">
                                            <button
                                                className="btn "
                                                onClick={() => {
                                                    navigate(
                                                        `/sectionEdit/${d.id}`
                                                    )
                                                }}
                                            >
                                                ویرایش
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </table>
                    </div>
                </main>
            </div>
        </>
    )
}

export default Sections
